var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"title":"Sessions vs Objectif","loading":_vm.loading,"colors":_vm.colors,"series":_vm.series,"yAxis":_vm.yAxis,"xAxis":_vm.xAxis,"dags":['ga_get_and_store_site_daily_dag']}})}
var staticRenderFns = []

export { render, staticRenderFns }